export enum CompanyType {
  CompanyAzureAd = "CompanyAzureAd",
}
